import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import Heading from 'components/shared/Heading'
import LazyImage from 'components/shared/LazyImage'
import Icon from 'components/shared/Icon'
import useMedia from 'hooks/useMedia'
import dotsSvg from 'assets/icons/illu_about.svg'

const Wrapper = styled.article`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.mq.xl} {
    flex-direction: row;
  }
`

const IconWrapper = styled.div`
  display: none;
  position: absolute;
  width: 80px;
  top: 15%;
  left: -10%;
  transform: translateY(-15%);
  pointer-events: none;
  ${({ theme }) => theme.mq.xl} {
    display: block;
  }
`

const Content = styled.div`
  position: relative;
  flex-basis: 80%;
  display: flex;
  flex-direction: column;
  padding: 30px 0;
  order: 1;
  ${({ theme }) => theme.mq.s} {
    padding: 60px;
    border: 1px solid ${({ theme }) => theme.white};
  }
  ${({ theme }) => theme.mq.xl} {
    order: ${({ right }) => (right ? '1' : '-1')};
  }
`

const Description = styled.p`
  padding-top: 30px;
  white-space: pre-wrap;
  line-height: 23px;
  font-size: 1.7rem;
  ${({ theme }) => theme.mq.s} {
    padding-top: 40px;
  }
`

const Link = styled.a`
  padding-top: 30px;
  white-space: pre-wrap;
  line-height: 23px;
  font-size: 1.7rem;
  color: inherit;
  text-decoration: none;
  font-weight: 600;

  ${({ theme }) => theme.mq.s} {
    padding-top: 20px;
  }
`

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`

const Card = ({ header, image, imageAlt, description, right }) => {
  const matchesS = useMedia('(min-width: 576px)')
  return (
    <Wrapper>
      {header.title.toLowerCase().includes('about') && (
        <IconWrapper>
          <Icon full src={dotsSvg} alt="dots" />
        </IconWrapper>
      )}
      <Content right={right}>
        <Heading title={header.title} highlight={header.highlight} />
        <Description dangerouslySetInnerHTML={{ __html: description }} />
        <Link href="https://pl.wikipedia.org/wiki/Victoria_Dom" rel="dofollow" target="_blank">
          Visit company’s profile on Wikipedia
        </Link>
      </Content>
      <ImageWrapper>
        <LazyImage
          height={matchesS ? 500 : 300}
          cover
          src={image}
          alt={imageAlt}
        />
      </ImageWrapper>
    </Wrapper>
  )
}

Card.propTypes = {
  header: PropTypes.objectOf(PropTypes.string).isRequired,
  image: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  imageAlt: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  right: PropTypes.bool,
}

Card.defaultProps = {
  right: false,
}

export default Card
